exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scoped-autocomplete-input-container[data-v-4d58584a]{position:relative}.scoped-autocomplete-list[data-v-4d58584a]{position:absolute;top:34px;left:0;width:100%;padding:0;margin:0;overflow:auto;border:1px solid #212121;background-color:#fff;list-style:none;max-height:290px}.scoped-autocomplete-list-item[data-v-4d58584a]{padding:4px 6px;border-bottom:1px solid #929292}.scoped-autocomplete-list-item.selected[data-v-4d58584a],.scoped-autocomplete-list-item[data-v-4d58584a]:hover{background-color:#dedede}.scoped-autocomplete-list-item[data-v-4d58584a]:last-of-type{border-bottom:none}", ""]);

// exports
